<!-- eslint-disable no-sequences -->
<!-- eslint-disable no-sequences -->
<!-- eslint-disable no-unused-expressions -->
<template>
  <div class="good-up" @click.stop="">
    <canvas ref="cvs" id="cvs"></canvas>
  </div>
</template>

<script>
import LikeHeart from '@/utils/thumbs-up';
import { mapGetters } from 'vuex'
export default {
  props: ['ClassTimePlayer', 'videoUrl'],
  data() {
    return {
      width: 0, // 初始宽度
      height: 0, // 初始高度
      heartList: [], // 初始数组
      heartCount: 0, // 累加计数初始值
      img: [
        require(`@/assets/good/good1.png`),
        require(`@/assets/good/good2.png`),
        require(`@/assets/good/good3.png`),
        require(`@/assets/good/good4.png`),
        require(`@/assets/good/good5.png`),
        require(`@/assets/good/good6.png`)
      ]
    };
  },
  computed: {
    ...mapGetters(['initGood'])
  },
  methods: {
    getRandomDis() {
      if (Math.random() > 0.5) {
        return -(Math.random() * 43 * 0.47);
      } else {
        return +(Math.random() * 43 * 0.47);
      }
    },
    createHeart() {
      this.heartCount++;
      let positionArray = [
        {
          x: this.width * 0.7,
          y: this.height,
          endX: this.width * 0.7,
          endY: this.height * 0.25
        }
      ];
      let img = new Image();
      img.src = `../../static/img/${Math.ceil(Math.random() * 5)}.png`;
      img.src = this.img[Math.ceil(Math.random() * 6) - 1];
      let p1 = {
        x: this.width * 0.7 + this.getRandomDis(),
        y: this.height * 0.75 + this.getRandomDis()
      };
      let p2 = {
        x: this.width * 0.7 + this.getRandomDis(),
        y: this.height / 2 + this.getRandomDis()
      };
      return new LikeHeart({
        id: this.heartCount,
        x: positionArray[0].x,
        y: positionArray[0].y,
        endX: positionArray[0].endX,
        endY: positionArray[0].endY,
        onFadeOut: this.removeItem,
        noAngel: true, // 决定是否从小到大
        // noScale: true,//决定是否左右摆动
        width: 30, // 决定心的大小
        height: 30,
        image: img,
        bezierPoint: {
          p0: {
            x: positionArray[0].x,
            y: positionArray[0].y
          },
          p1: p1,
          p2: p2,
          p3: {
            x: positionArray[0].endX,
            y: positionArray[0].endY
          }
        }
      });
    },
    removeItem(item) {
      var array = [];
      for (var i = 0; i < this.heartList.length; i++) {
        if (this.heartList[i].id !== item.id) {
          array.push(this.heartList[i]);
        }
      }
      this.heartList = array;
    },
    // 初始化
    init() {
      // 飘心
      var _this = this;
      var ctx = document.getElementById('cvs').getContext('2d');
      // eslint-disable-next-line no-unused-expressions, no-sequences
      (ctx.canvas.width = _this.width),
      (ctx.canvas.height = _this.height),
      (function loop() {
        ctx.clearRect(0, 0, _this.width, _this.height);
        _this.heartList.forEach(function(item) {
          item && item.move(ctx);
        });
        requestAnimationFrame(loop);
      })();
    },
    // 点击飘♥
    floatStar() {
      this.heartList.push(this.createHeart())
    }
  },
  created() {
    // document.onreadystatechange = () => {
    //   switch (document.readyState) {
    //     case 'complete':
    //       this.width = this.$refs.cvs.clientWidth
    //       this.height = this.$refs.cvs.clientHeight * 0.95
    //       this.init()
    //       this.$store.commit('state/SET_INITGOOD', true)
    //       break;
    //   }
    // }
  },
  mounted() {
    setTimeout(() => {
      this.width = this.$refs.cvs.clientWidth
      this.height = document.body.clientHeight * 0.29
      this.init()
    }, 100)
  }
};
</script>

<style lang="scss" scoped>
  .good-up {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    #cvs {
      width: 100%;
      // height: 100%;
    }
  }
</style>
